import { TextContainerStyleSheetAll } from "@client/content/Containers/Text/container";
import { getContainerProps, getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import * as React from "react";

export type TextHTMLComponentProps = RootContainerProps & {
  description: string;
};

export default (props: TextHTMLComponentProps) => {
  const style = React.useMemo(
    () => ({
      whiteSpace: "pre-wrap"
    }),
    []
  );

  return (
    <TextContainerStyleSheetAll {...getContainerProps(props)}>
      <props.TextComponent
        {...getEntityRef(props)}
        toolbar={"extended"}
        html={props.description}
        prop="description"
        style={style}
      />
    </TextContainerStyleSheetAll>
  );
};
